import React from "react";
import {
  Card,
  CardBody,
  Input,
  Button,
  Label,
  Container,
  Row,
  Col,
  Form,
} from "reactstrap";
import { useForm, Controller } from "react-hook-form";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import "flatpickr/dist/themes/material_blue.css";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { post } from "helpers/api_helper";
import { useNavigate } from "react-router-dom";
import { USER_CREATE } from "helpers/url_helper";

const CreateUser = () => {
  const navigate = useNavigate();
  const {
    control,
    handleSubmit,
    reset,
    formState: { isSubmitting, errors },
  } = useForm({
    defaultValues: {
      name: "",
      phone: "",
      email: "",
      password: "",
      role: "",
    },
  });

  const roles = [
    { label: "Admin", value: 1 },
    { label: "Accountant", value: 3 },
  ];

  const breadcrumbItems = [
    { title: "ValFuel", link: "/" },
    { title: "Add User", link: "#" },
  ];

  const onSubmit = async (data) => {
    try {
      const res = await post(USER_CREATE, {
        ...data,
        role: Number(data.role),
      });
      console.log("res", res);
      toastr.success("User created successfully");
      reset();
      navigate("/users");
    } catch (err) {
      toastr.error(err?.response?.data?.message || "Failed to create user");
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Add User" breadcrumbItems={breadcrumbItems} />
        </Container>

        <Row>
          <Col xl="12">
            <Card>
              <CardBody>
                <Form
                  className="needs-validation"
                  method="post"
                  id="customerCreateForm"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <Row>
                    <Col md="6" xl="4">
                      <div className="mb-3 position-relative">
                        <Label className="form-label" htmlFor="phone">
                          Phone No <span className="text-danger">*</span>
                        </Label>

                        <Controller
                          name="phone"
                          control={control}
                          rules={{
                            required: "Phone number is required",
                            pattern: {
                              value: /^[0-9]*$/, // only numbers
                              message: "Please enter only numbers",
                            },
                            minLength: {
                              value: 10,
                              message: "Must be 10-digits phone number",
                            },
                            maxLength: {
                              value: 10,
                              message: "Must be 10-digits phone number",
                            },
                          }}
                          render={({ field }) => (
                            <Input
                              {...field}
                              id="phone"
                              placeholder="Enter Phone no"
                              type="tel" // opens phone's dial pad
                              inputMode="numeric" // fallback to show numeric keyboard
                              pattern="[0-9]*"
                              maxLength="10"
                              onKeyDown={(e) => {
                                // block non-digits
                                if (
                                  !/[0-9]|Backspace|ArrowLeft|ArrowRight|Tab|Delete/.test(
                                    e.key
                                  )
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={`form-control ${
                                errors?.phone ? "is-invalid" : ""
                              }`}
                            />
                          )}
                        />
                        {errors?.phone?.message && (
                          <div className="text-danger">
                            {errors.phone.message}
                          </div>
                        )}
                      </div>
                    </Col>
                    <Col md="6" xl="4">
                      <div className="mb-3 position-relative">
                        <Label
                          className="form-label"
                          htmlFor="validationTooltip03"
                        >
                          Email
                          <span className="text-danger">*</span>
                        </Label>
                        <Controller
                          name="email"
                          control={control}
                          rules={{
                            required: "Email is required",
                            pattern: {
                              value:
                                /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                              message: "Invalid email format",
                            },
                          }}
                          render={({ field }) => (
                            <Input
                              {...field}
                              type="text"
                              className={`form-control ${
                                errors.email ? "is-invalid" : ""
                              }`}
                              id="email"
                              placeholder="Enter Email"
                            />
                          )}
                        />
                        {errors?.email?.message && (
                          <div className="text-danger">
                            {errors?.email.message}
                          </div>
                        )}
                      </div>
                    </Col>
                    <Col md="6" xl="4">
                      <div className="mb-3 position-relative">
                        <label className="form-label" htmlFor="name">
                          {" "}
                          Name{" "}
                        </label>
                        <Controller
                          name="name"
                          control={control}
                          rules={{
                            required: "Name is required",
                          }}
                          render={({ field }) => (
                            <Input
                              {...field}
                              type="text"
                              className={`form-control ${
                                errors.name ? "is-invalid" : ""
                              }`}
                              id="name"
                              placeholder="Enter name"
                            />
                          )}
                        />
                      </div>
                    </Col>
                    <Col md="6" xl="4">
                      <div className="mb-3 position-relative">
                        <Label className="form-label">Password</Label>
                        <Controller
                          name="password"
                          control={control}
                          rules={{
                            required: "Password is required",
                          }}
                          render={({ field }) => (
                            <Input
                              {...field}
                              type="password"
                              className={`form-control ${
                                errors.password ? "is-invalid" : ""
                              }`}
                              id="password"
                              placeholder="Enter password"
                            />
                          )}
                        />
                        {errors?.password?.message && (
                          <div className="text-danger">
                            {errors?.password.message}
                          </div>
                        )}
                      </div>
                    </Col>
                    <Col md="6" xl="4">
                      <div className="mb-3 position-relative">
                        <Label className="form-label">Role</Label>
                        <Controller
                          name="role"
                          control={control}
                          rules={{
                            required: "Role is required",
                          }}
                          render={({ field }) => (
                            <Input
                              {...field}
                              type="select"
                              className={`form-control ${
                                errors.role ? "is-invalid" : ""
                              }`}
                              id="role"
                              placeholder="Select Role"
                            >
                              <option key="" value="">
                                Select role
                              </option>
                              {roles.map((role) => (
                                <option key={role.value} value={role.value}>
                                  {role.label}
                                </option>
                              ))}
                            </Input>
                          )}
                        />
                        {errors?.role?.message && (
                          <div className="text-danger">
                            {errors?.role.message}
                          </div>
                        )}
                      </div>
                    </Col>
                  </Row>
                  <div className="text-end">
                    <Button
                      type="submit"
                      color="primary"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Submitting..." : "Submit"}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default CreateUser;
